export default "__VITE_ASSET__BkSw$3gK__"